
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.712 15.16a2.893 2.893 0 01-2.125-.874 2.893 2.893 0 01-.875-2.125c0-.834.292-1.542.875-2.125a2.893 2.893 0 012.125-.875v-2c0-.55.196-1.021.588-1.412a1.923 1.923 0 011.412-.588h3c0-.834.292-1.542.875-2.125a2.893 2.893 0 012.125-.875c.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125h3c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v2c.833 0 1.542.291 2.125.875.583.583.875 1.291.875 2.125 0 .833-.292 1.541-.875 2.125a2.893 2.893 0 01-2.125.875v4c0 .55-.196 1.02-.587 1.413a1.928 1.928 0 01-1.413.587h-12c-.55 0-1.02-.196-1.412-.587a1.927 1.927 0 01-.588-1.413v-4zm5-2c.417 0 .77-.145 1.062-.437.292-.292.438-.646.438-1.062 0-.417-.146-.771-.438-1.062a1.444 1.444 0 00-1.062-.438c-.417 0-.77.146-1.062.438a1.444 1.444 0 00-.438 1.062c0 .416.146.77.438 1.062.291.292.645.438 1.062.438zm6 0c.417 0 .77-.145 1.062-.437.292-.292.438-.646.438-1.062 0-.417-.146-.771-.438-1.062a1.444 1.444 0 00-1.062-.438c-.417 0-.77.146-1.062.438a1.444 1.444 0 00-.438 1.062c0 .416.146.77.438 1.062.291.292.645.438 1.062.438zm-7 4h8v-2h-8v2z"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    